module.exports = __webpack_public_path__ + "img/horizontal-logo-white.fbd65038.svg";